// @flow
// PIBLICLINK CONSTANTS
export const PUBLIC_LINK_INIT = "PUBLIC_LINK_INIT";
export const PUBLIC_LINK_OPEN_FOLDER = "PUBLIC_LINK_OPEN_FOLDER";
export const PUBLIC_LINK_DISPOSE = "PUBLIC_LINK_DISPOSE";
